import React, { useState, useEffect } from 'react';
import AuthContext from "./contexts/AuthContext";
import {
  getToken,
  setRefreshToken as setStorageRefreshToken,
  setToken as setStorageToken, unsetImpersonate,
  unsetRefreshToken,
  unsetToken
} from "./tokenStorage";
import jwtDecode from "jwt-decode";
import {postLogin, postRefreshToken} from "./api/login";
import axios from "src/api/axiosInstance";
import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";
import userApi from "src/api/user/userApi";

const AuthProvider = ({ children }) => {
  const [consumeRefreshTokenTimeoutId, setConsumeRefreshTokenTimeoutId] = useState(undefined);
  const [myUser, setMyUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (myUser === null && getToken()) {
      refreshMyUser();
    }
  }, [])

  const refreshMyUser = async () => {
    const myUser = await userApi.retrieveMe();
    setMyUser(myUser);
  }

  function setConsumeRefreshBeforeExpiration(token, refreshToken) {
    const payload = jwtDecode(token);
    let expiresInSeconds = payload.exp - Math.ceil((new Date().getTime() / 1000));
    // Refresh 5 seconds before expiring
    const timeoutSeconds = expiresInSeconds - 5;
    const timeoutId = setTimeout(() => consumeRefreshToken(refreshToken), timeoutSeconds * 1000);
    setConsumeRefreshTokenTimeoutId(timeoutId);
  }

  const consumeRefreshToken = async (refreshToken) => {
    try {
      const response = await postRefreshToken(refreshToken);
      if (response) {
        handleTokenResponse(response);
      }
    } catch (error) {
      if (error.response) {
        const refreshTokenHasExpired = 401 === error.response.status;
        if (refreshTokenHasExpired) {
          handleLogout();
        }
      }
    }
  }

  function handleTokenResponse(response) {
    const token = response.data.token;
    const refreshToken = response.data['refresh_token'];
    setStorageToken(token);
    setStorageRefreshToken(refreshToken);
    axios.defaults.headers['Authorization'] = `Bearer ${token}`;
    // auto refresh token
    setConsumeRefreshBeforeExpiration(token, refreshToken);
    refreshMyUser();
  }

  const handleLogin = async (username, password) => {
    const response = await postLogin(username, password);
    // Be sure to set token before navigating, otherwise the homepage may be loaded without the token set, resulting in 401s
    await handleTokenResponse(response);
    navigate('/');
  }

  const handleLogout = () => {
    unsetRefreshToken();
    if (consumeRefreshTokenTimeoutId) {
      clearTimeout(consumeRefreshTokenTimeoutId);
      setConsumeRefreshTokenTimeoutId(null);
    }

    unsetToken();
    unsetImpersonate();
    delete axios.defaults.headers['Authorization'];

    navigate('/login', {state: { from: location }});
  }

  const value = {
    setConsumeRefreshBeforeExpiration,
    consumeRefreshToken,
    onLogin: handleLogin,
    onLogout: handleLogout,
    myUser,
    refreshMyUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;

AuthProvider.propTypes = {}

AuthProvider.defaultProps = {}